import React from 'react'
import * as jnb from "react-bootstrap";
import { FaEdit } from 'react-icons/fa';
import { FaCircleArrowLeft } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';

export const CommonPageHeading = (props) => {
    const { heading, navigateData, path, handleDrillBack, drillBack, back, EditMSG } = props;
    let navigate = useNavigate();
    return (
        <jnb.Row className='mt-3'>
            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between">
                {heading ? (<div className="heading-main">
                    <h3 className="main-title">{heading}</h3>
                </div>) : <div></div>}
                <div className='print-in-hide'>
                    {back === false ? null : <div className="print-outside-hide_inside mt-2">
                        {drillBack === 'true' ? <button type='button' className={EditMSG ? "btn btn-primary" : 'btn btn-secondary'}
                            onClick={() => { handleDrillBack() }}>
                            {EditMSG ? <> <FaEdit size={20} /> &nbsp;{EditMSG}</> : <> <FaCircleArrowLeft size={20} /> &nbsp;Back</>}
                        </button> :
                            (<> {path !== undefined ?
                                <button type='button' className="btn btn-secondary" onClick={() => { navigate(path, { state: { data: navigateData } }) }}><FaCircleArrowLeft size={20} /> &nbsp;Back</button> :
                                <button type='button' className="btn btn-secondary" onClick={() => { navigate(-1) }}><FaCircleArrowLeft size={20} /> &nbsp;Back</button>
                            }</>)}
                    </div>}</div>
            </jnb.Col>
        </jnb.Row>

    )

}
